import {action, observable} from "mobx"
// import _ from "lodash"

export default class AddressStore {

  constructor(api) {
    this.api = api
    this.api.events.authentified.add( this.onLogin )
  }

  @observable list            = []
  @observable byId            = new Map()
  @observable deliveryAddress = false
  @observable invoiceAddress  = false
  @observable baseAddress     = false

  onLogin = () => {
    this.fetch()
  }

  @action fetch() {
    fetch( `${this.api.config.API}data/customers/current/addresses/deliver`, {
      credentials: "include"
    } )
      .then( res => res.json() )
      .then( locations => {
        if ( locations.length < 1 ) {
          return
        }

        this.deliveryAddress = locations[0]
        this.invoiceAddress = locations[0]
        this.baseAddress = locations[0]

        this.list = locations
        this.list.forEach( loc => {
          this.byId.set( loc.mapid, loc )
        } )
      } )

  }
}




// WEBPACK FOOTER //
// ./src/sdk/store/AddressStore.js